var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from "lit";
import { customElement, PICBase, stringDecoder } from "../Internals";
import { property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
let PICAddSpace = class PICAddSpace extends PICBase {
    setComponentInlineStyle() {
        this.width ? this.style.setProperty('width', this.width) : this.style.setProperty('width', '0px');
        this.height ? this.style.setProperty('height', this.height) : this.style.setProperty('width', '0px');
    }
    getDivStyle() {
        return {
            'width': this.width,
            'min-width': this.width,
            'max-width': this.width,
            'height': this.height,
            'min-height': this.height,
            'max-height': this.height,
        };
    }
    render() {
        this.setComponentInlineStyle();
        return html `
            <div style=${styleMap(this.getDivStyle())}></div>
        `;
    }
};
__decorate([
    property({ converter: stringDecoder })
], PICAddSpace.prototype, "width", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICAddSpace.prototype, "height", void 0);
PICAddSpace = __decorate([
    customElement('pic-addspace')
], PICAddSpace);
export { PICAddSpace };
//# sourceMappingURL=PICAddSpace.js.map